import { DefaultAccessRepository } from "./accessRepository/AccessRepository";
import { DefaultCommentRepository } from "./commentRepository/CommentRepository";
import { DefaultUserRepository } from "./userRepository/UserRepository";

export class CommonRepoContainer {
  public static accessRepo = new DefaultAccessRepository();
  public static userRepo = new DefaultUserRepository();
  public static commentRepo = new DefaultCommentRepository();
}
